// extracted by mini-css-extract-plugin
export default {"switcher_label":"Switcher_switcher_label__eD4B6","switcher_input":"Switcher_switcher_input__jCkBd"};